module.exports = __webpack_public_path__ + "static/media/radiobutton_white.3c61892e.svg";